module.exports = __webpack_public_path__ + "img/main6.33734c4d.png";